import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { FirebaseContext } from "../lib/firebase";

const Register = () => {
  const { auth, api } = useContext(FirebaseContext);
  const { registerWithEmailAndPassword } = api;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [teamPassword, setTeamPassword] = useState("");
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      // maybe trigger a loading screen
      return;
    }
    if (!user) navigate("/");
  }, [user, loading, navigate]);
  return (
    <div className='login'>
      <div className='login__container'>
        <input
          type='text'
          className='login__textBox team-password'
          value={teamPassword}
          onChange={(e) => setTeamPassword(e.target.value)}
          placeholder='Team Password'
        />
        <input
          type='email'
          className='login__textBox'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='E-mail Address'
        />
        <input
          type='password'
          className='login__textBox'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder='Password'
        />
        <button
          className='login__btn'
          onClick={async () => {
            await registerWithEmailAndPassword(email, password, teamPassword);
            navigate("/");
          }}
        >
          Register New User
        </button>
      </div>
    </div>
  );
};
export default Register;
